<homey-notification-dialog-content [title]="data().title" [closeButton]="closeButton()">
  <div class="wysiwig" [innerHTML]="markdown()">

  </div>
</homey-notification-dialog-content>
